import StrategyCallButton from './StrategyCallButton'

const defaultContent = {
    eyebrow: 'Direct Mail Services',
    title: 'Everything you need to run direct mail',
    gradientTitle: 'like a serious channel.',
    description:
        'From strategy and audience targeting through creative, production, and high-volume execution. Work with one partner who handles every part of the campaign, or just the parts you need help with.',
    cta: {
        label: 'Book a strategy call ->',
        href: '/contact-us',
    },
}

export default function ServicesHero(props) {
    const eyebrow = props?.eyebrow || defaultContent.eyebrow
    const title = props?.title || defaultContent.title
    const gradientTitle = props?.gradientTitle || defaultContent.gradientTitle
    const description = props?.description || defaultContent.description
    const cta = props?.cta || defaultContent.cta

    return (
        <section className="border-b border-black/10 bg-[#fff7ed]">
            <div className="container mx-auto px-4 py-16 md:py-20">
                <div className="mx-auto max-w-4xl text-center">
                    <div className="inline-flex items-center gap-2 rounded-full border border-olm/20 bg-[#ffe8db] px-4 py-[6px]">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#ED5C45]" />
                        <span className="text-xs font-semibold uppercase leading-7 text-[#ED5C45] tracking-[0.6px]">
                            {eyebrow}
                        </span>
                    </div>

                    <h1 className="mt-6 text-[48px] font-[700] tracking-tight text-olm-new-black leading-[1.05]">
                        {title}
                    </h1>

                    <div className="mt-2 text-[48px] font-[700] tracking-tight leading-[1.05]">
                        <span className="bg-[linear-gradient(90deg,#F28230_0%,#ED5C2F_48%,#FAB331_100%)] bg-clip-text text-transparent">
                            {gradientTitle}
                        </span>
                    </div>

                    <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-olm-black/70">
                        {description}
                    </p>

                    {cta?.label ? (
                        <div className="mt-8 flex justify-center">
                            <StrategyCallButton className="inline-flex items-center justify-center rounded-full bg-rtl-gradient px-8 py-4 text-base font-semibold text-white shadow-lg transition hover:opacity-95">
                                {cta.label}
                            </StrategyCallButton>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    )
}
